import React, { useEffect, useState, useRef } from "react";
import Users from "../../../component/System/Users";
import { generatePath, useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import usersData from "./tableData.json";
import { connect } from "react-redux";
import { loadingShow } from '../../../services/PostAPI';
import { fetchUser, initializeUserInfoScreen, saveUsersTableState } from "../../../redux/actions/System/Users";
import { FILTER } from '../../../services/common/urlService';
import { DATE_STRATEGY, formatDate } from '../../../utils/date';

const UsersScreen = (props) => {
  const {
    fetchUser,
    initializeUserInfoScreen,
    screenPermissions,
    showPageLevelLoader,
    userListView,
    paginationInfo,
    isLoading,
    savedTableState,
    saveUsersTableState,
  } = props;

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initializeUserInfoScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchUser(savedParams);
    } else {
      fetchUser({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const navigate = useNavigate();
  const [confirmationPopup, setConfirmationPopup] = useState(false);

  const handleCreateUsers = () => {
    navigate(APP_URLS.SYSTEM_USERS.CREATE);
  };

  const handleEditUsers = (id) => {
    const path = generatePath(APP_URLS.SYSTEM_USERS.EDIT, {
      id,
    });
    navigate(path);
  };

  const setDeleteConfirmationPopupVisibility = (payload) => {
    setConfirmationPopup(payload);
  };

  const loadLazyData = (props) => {
    let newProps = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchUser(newProps);
  };
  
  // Callback to save raw table state for restoration after navigation
  const handleTableStateChange = (rawParams) => {
    saveUsersTableState(rawParams);
  };

  const UsersProps = {
    handleCreateUsers,
    handleEditUsers,
    screenPermissions,
    tableData: {
      columns: userListView?.columns,
      rows: userListView?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    fetchUsersInfos: loadLazyData,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    isLoading,
    setDeleteConfirmationPopupVisibility,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");

  return (
    <div>
      <Users {...UsersProps} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializeUserInfoScreen: () => dispatch(initializeUserInfoScreen()),
    fetchUser: (payload) => dispatch(fetchUser(payload)),
    saveUsersTableState: (payload) => dispatch(saveUsersTableState(payload)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    userListView: selectUsersList(state.userReducer),
    showPageLevelLoader: selectIsLoadingPage(state.userReducer),
    paginationInfo: selectPaginationInfo(state.userReducer),
    isPageLevelError: selectIsPageLevelError(state.userReducer),
    isFetchingGridData: selectIsLoading(state.userReducer),
    savedTableState: selectSavedTableState(state.userReducer),
  };
};

const selectUsersList = (userReducer) => userReducer?.userListView;
const selectIsLoadingPage = (userReducer) => userReducer?.isLoadingPage;
const selectPaginationInfo = (userReducer) => userReducer?.paginationInfo;
const selectIsPageLevelError = (userReducer) => userReducer?.isPageLevelError;
const selectIsLoading = (userReducer) => userReducer?.isLoading;
const selectSavedTableState = (userReducer) => userReducer?.savedTableState;

export default connect(mapStateToProps, mapDispatchToProps)(UsersScreen);

